<template>
  <div id="app" ref="app">
    <!-- <el-scrollbar > -->
    <!-- 头部 -->
    <srm-header />

    <router-view />
    <!-- 底部 -->
    <srm-footer />
    <!-- </el-scrollbar> -->
  </div>
</template>

<script>
import srmHeader from './components/srm-header'
import srmFooter from './components/srm-footer'
export default {
  name: 'App',
  components: { srmHeader, srmFooter },
  methods: {
    checkDeviceAndRedirect () {
      const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      )
      if (isMobile) {
        console.log('mobile detected')
        window.location.href = 'https://wisdom-srm.com/srmmobile'
      }
    },
    // 防抖函数
    debounce (func, wait = 300) {
      let timeout
      return (...args) => {
        clearTimeout(timeout)
        timeout = setTimeout(() => {
          func.apply(this, args)
        }, wait)
      }
    }
  },
  mounted () {
    // 页面加载时立即执行一次
    this.checkDeviceAndRedirect()

    // 用防抖包裹函数，避免 resize 频繁触发
    this._resizeHandler = this.debounce(this.checkDeviceAndRedirect, 300)

    // 监听窗口变化
    window.addEventListener('resize', this._resizeHandler)
  },
  beforeDestroy () {
    // 移除监听器
    window.removeEventListener('resize', this._resizeHandler)
  }
}
</script>

<style lang="scss">
* {
  margin: 0;
  padding: 0;
  border: 0;
}

#app {
  min-width: 1200px;

  .view-conten {
    margin-top: 56px;
  }
}

.el-popup-parent--hidden {
  // padding-right: 17px !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue